import { useWeb3 } from './useWeb3';

export async function getCurrentBlock(): Promise<number> {
  const web3 = useWeb3();
  const currentBlockNumber = await web3.provider.getBlockNumber();
  return currentBlockNumber;
}
